import * as navActions from '/@/store/nav/actions';
import * as weedFinderActions from '/@/store/weed-finder/actions';
/* eslint-disable max-len */
import * as trackingActions from './actions';
import events from './events';
import { pushToGTMGA } from './utils';

const sendEvent = (key, payload, state) => {
    const event = typeof events[key] === 'function' ? events[key](payload) : events[key];
    if (state && state.network.offline) {
        const events = JSON.parse(localStorage.getItem('events')) || [];
        if (event.label) {
            event.label = `[Offline] ${event.label}`;
        } else {
            event.label = '[Offline]';
        }
        events.push(event);
        localStorage.setItem('events', JSON.stringify(events));
    } else {
        pushToGTMGA(event);
    }
};

const getLabel = (items, value, valueKey = 'id', labelKey = 'name') => {
    const item = items.find((item) => item[valueKey] === value);
    return item && item[labelKey];
};

const getGaHandlers = {
    [trackingActions.trackEvent]: ({ key, ...payload }, state) => sendEvent(key, payload, state),

    [navActions.openMenu]: () => sendEvent('menu.open'),
    [navActions.closeMenu]: () => sendEvent('menu.close'),
    [navActions.clickMenu]: (payload) => sendEvent('menu.click', payload),
    [navActions.closeMenuFromIcon]: () => sendEvent('menu.closeIcon'),
    [navActions.closeMenuFromOverlay]: () => sendEvent('menu.closeOverlay'),

    [weedFinderActions.reset]: () => sendEvent('weedFinder.reset'),
    [weedFinderActions.setViewType]: (payload) => sendEvent('weedFinder.viewType', payload),
    // [weedFinderActions.setFilter]: (payload, state) => {
    //     const selectorsByGroup = {
    //         type: publicDataSelectors.getWeedTypes,
    //         cycle: publicDataSelectors.getWeedCycles,
    //         biotype: publicDataSelectors.getWeedBiotypes,
    //         weatherSeason: publicDataSelectors.getWeedWeatherSeasons,
    //     };
    //     const label = getLabel(selectorsByGroup[payload.group](state), payload.value);
    //     return sendEvent('weedFinder.filter', { adding: payload.adding, label });
    // },
    [weedFinderActions.setSearch]: (payload) => sendEvent('weedFinder.search', payload),
};

const sendOfflineEvents = (action, state) => {
    if (action.type === 'NETWORK:ONLINE') {
        const events = JSON.parse(localStorage.getItem('events')) || [];
        events.forEach((event) => pushToGTMGA(event));
        localStorage.removeItem('events');
    }
};

const middleware = (store) => {
    // eslint-disable-line no-unused-vars
    return (next) => {
        const gaHandlers = getGaHandlers;
        return (action) => {
            next(action);
            sendOfflineEvents(action, store.getState());
            if (gaHandlers[action.type]) gaHandlers[action.type](action.payload, store.getState());
        };
    };
};

export default middleware;
